import { render, staticRenderFns } from "./MeMarunageList.vue?vue&type=template&id=baded4ce&"
import script from "./MeMarunageList.vue?vue&type=script&lang=js&"
export * from "./MeMarunageList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports